import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  IMAGE_BORDER_RADIUS,
  VIEW_BESIDE_PREVIEW_MAX_WIDTH,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {Button} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import ValueHelper, {getInitialFiles} from "../../utils/ValueHelper";
import constants from "../../constants";
import FileHelper from "../../utils/FileHelper";
import InputLabel from "@material-ui/core/InputLabel";
import SingleFilePicker, {
  ACCEPTED_AUDIO_MIMES,
  ACCEPTED_IMAGE_MIMES, AUDIO_MAX_SIZE, FILE_TYPE_AUDIO,
  FILE_TYPE_IMAGE,
  IMAGE_MAX_SIZE,
  IMAGE_MAX_WIDTH_HEIGHT,
  IMAGE_PROFILE_MAX_WIDTH_HEIGHT,
} from "../commons/SingleFilePicker";
import MapField, {MAP_EXTRA_HEIGHT, ZOOM_COARSE_LOCATION} from "../commons/MapField";
import {
  ColorActivityFormImage,
  ColorFieldBorder, ColorGreen,
  ColorNegative,
  ColorSubTitle,
  ColorTheme
} from "src/styles/Colors";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import DateTimeHelper from "../../utils/DateTimeHelper";
import DeleteIcon from "@material-ui/icons/Delete";
import TextView from "../commons/TextView";
import {FontWeightMedium} from "src/res/FontWeight";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import DialogView from "../commons/DialogView";
import FormHelperText from "@material-ui/core/FormHelperText";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";
import View from "src/js/components/commons/View";
import TouchableOpacity from "src/js/components/commons/TouchableOpacity";

const useStyles = (theme) => ({
  videoPreview: {
    borderRadius: BORDER_RADIUS,
    border: '5px solid '+ ColorTheme,
    marginLeft: 32,
    marginRight: 32,
    // marginBottom: 2 * FIELD_SPACE,
    width: 320,
    height: 640,
    [theme.breakpoints.down('md')]: {
      width: 280,
      height: 560,
    }
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    padding: 8,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    minWidth: 260,
    width: '100%',
    marginBottom: 16
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
  },
  imageCustomisePlaceholderIcon: {
    width: 48,
    height: 48,
    borderRadius: BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageCustomise1: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    marginBottom: 16,
    padding: 4,
  },
});

const CHALLENGE_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.random'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.topViewed'/>},
  {'id': 2, 'name': <FormattedMessage id='activity.manage.winnersBy.topLiked'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.manage.winnersBy.downloadedOnly'/>},
];

const LAZY_WIN_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.topCollectors'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.moreThanValue'/>, 'showWinnersByValue': true},
];

const QUESTIONNAIRE_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.questionnaire.top'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.questionnaire.moreThanValue'/>, 'showWinnersByValue': true},
];

const IDENTIFY_LOCATION_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.identifyLocation.nearest'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.identifyLocation.lessThanValue'/>, 'showWinnersByValue': true},
];

class ManageActivityIdentifyLocation extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    this.key = 0;

    this.startAt = activityData.startAt instanceof Date ? activityData.startAt : DateTimeHelper.getDateFromDateString(activityData.startAt)
    this.maxGamePlayAudioDuration = 10*1000;
    this.maxBgAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxGamePlayAudioDuration = activityData.mediaConfigs.maxGamePlayAudioDuration;
      this.maxBgAudioDuration = activityData.mediaConfigs.maxBgAudioDuration;
    }

    this.slotMinValues = 0;
    this.slotMaxValues = 0;
    this.slotMinImages = 0;
    this.slotMaxImages = 0;
    this.slotTotalImages = 0;
    this.maxWinOffersCount = 0;
    if (activityData.activityConfigs) {
      this.slotMinValues = activityData.activityConfigs.slotMinValues;
      this.slotMaxValues = activityData.activityConfigs.slotMaxValues;
      this.slotMinImages = activityData.activityConfigs.slotMinImages;
      this.slotMaxImages = activityData.activityConfigs.slotMaxImages;
      this.maxWinOffersCount = activityData.activityConfigs.maxWinOffersCount;
    }

    let contentTypeText = false;
    let contentTypeImage = false;
    let contentTypeAudio = false;
    let contentTypeVideo = false;
    if (activityData.contentTypes && (activityData.type === constants.activity.types.CHALLENGE || activityData.type === constants.activity.types.SOCIAL_CONTENT)) {
      activityData.contentTypes.forEach((value) => {
        if (value == '1') {
          contentTypeText = true;
        } else if (value == '2') {
          contentTypeImage = true;
        } else if (value == '3') {
          contentTypeAudio = true;
        } else if (value == '4') {
          contentTypeVideo = true;
        }
      });
    }

    this.winnersByOptions = LAZY_WIN_FUN_WINNERS_BY;
    if (activityData.type === constants.activity.types.CHALLENGE || activityData.type === constants.activity.types.SOCIAL_CONTENT) {
      this.winnersByOptions = CHALLENGE_WINNERS_BY;
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      this.winnersByOptions = IDENTIFY_LOCATION_FUN_WINNERS_BY;
    }

    let winnersBySelected = null;
    this.winnersByOptions.forEach((typeObj) => {
      if (activityData.winnersBy == typeObj.id) {
        winnersBySelected = typeObj;
      }
    });
    if (!winnersBySelected) {
      winnersBySelected = this.winnersByOptions[0];
    }

    let value1PlaceholderAr = activityData.value1PlaceholderAr;
    if (!value1PlaceholderAr && activityData.type === constants.activity.types.PREDICTION) {
      value1PlaceholderAr = activityData.value2Placeholder;
    }

    const endAtA = activityData.type === constants.activity.types.PREDICTION && activityData.endAtA ? activityData.endAtA : activityData.endAt;
    const latitude = activityData.rightOptionHint ? parseFloat(activityData.rightOptionHint) : null;
    const longitude = activityData.rightOptionHintAr ? parseFloat(activityData.rightOptionHintAr) : null;

    this.state = {
      sections: [
        {id: 1, labelId: 'activity.correctAnswer', subLabelId: 'activity.correctAnswerHint', expand: true, expandAlways: true},
        {id: 2, labelId: 'activity.correctLocation', subLabelId: 'activity.correctLocationHint', expand: true, expandAlways: true},
      ],
      feedbackHint: activityData.feedbackHint || '',
      clickLimit: activityData.clickLimit && activityData.clickLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.clickLimit : '',
      endAtA: endAtA instanceof Date ? endAtA : DateTimeHelper.getDateFromDateString(endAtA),
      isGamePuzzleSubTypeTap: activityData.subType == 1,
      videoFromGallery: activityData.consumableAt == 1,
      flipsNeeded: activityData.flipsNeeded || '0',
      deadCount: activityData.deadCount || '0',
      gameTime: activityData.gameTime / 1000,
      gameColumns: activityData.gameColumns || '',
      gameRows: activityData.gameRows || '',
      gameSColumns: activityData.gameSColumns || '',
      resetGameDays: activityData.consumeLimitPerDay || '',
      resetLimitPerUser: activityData.resetLimitPerUser != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.resetLimitPerUser : '',
      contactNumber: activityData.feedbackHint || '',
      winnersBySelected: winnersBySelected,
      winnersByValue: activityData.winnersByValue || '0',
      qTitle: activityData.qTitle || '',
      qTitleAr: activityData.qTitleAr || '',
      value1Placeholder: activityData.value1Placeholder || '',
      value1PlaceholderAr: value1PlaceholderAr || '',
      rightOptionHint: activityData.rightOptionHint || '',
      rightOptionHintAr: activityData.rightOptionHintAr || '',
      latitude: latitude,
      longitude: longitude,
      contentTypeText: contentTypeText,
      contentTypeImage: contentTypeImage,
      contentTypeAudio: contentTypeAudio,
      contentTypeVideo: contentTypeVideo,
      imageUrl1: activityData.imageUrl1,
      imageFiles1: activityData.imageFiles1,
      fileObjsImage1: activityData.fileObjsImage1,
      isImageDeleted1: activityData.isImageDeleted1,
      imageFiles2: activityData.imageFiles2,
      fileObjsImage2: activityData.fileObjsImage2,
      isImageDeleted2: activityData.isImageDeleted2,
      imageActionUrl: activityData.imageActionUrl,
      imageActionFiles: activityData.imageActionFiles,
      isImageActionDeleted: activityData.isImageActionDeleted,
      bgAudioUrl: activityData.bgAudioUrl,
      bgAudioFiles: activityData.bgAudioFiles,
      isBgAudioDeleted: activityData.isBgAudioDeleted,
      gamePlayAudioUrl: activityData.gamePlayAudioUrl,
      gamePlayAudioFiles: activityData.gamePlayAudioFiles,
      isGamePlayAudioDeleted: activityData.isGamePlayAudioDeleted,
      actionMessage: activityData.actionMessage,

      winPoints: activityData.winPoints || '0',
      winLimit: activityData.winLimit || '1',
      winILimit: activityData.winILimit || '0',
      activityRewarded: activityData.offer,
      activityRewardedSearch: activityData.offer ? activityData.offer.name : '',
      isActivityRewardedLoading: false,
      showValidationMsg: false,
      reload: false,
    };

    this.initialFiles1 = getInitialFiles(activityData.imageFiles1, activityData.imageUrl1, FILE_TYPE_IMAGE);
    this.bgAudioInitialFiles = getInitialFiles(activityData.bgAudioFiles, activityData.bgAudioUrl, FILE_TYPE_AUDIO);
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getRandomWeightage() {
    return Math.max(10, Math.floor((Math.random() * 100)));
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      qTitle,
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      isImageDeleted1,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioUrlDeleted,
      latitude,
      longitude,
    } = this.state;

    if (!excludeError) {
      if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
        if (this.isTitleIncorrect(qTitle) || !latitude || !longitude) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      }
    }

    return {
      qTitle,
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      isImageDeleted1,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioUrlDeleted,
      rightOptionHint: latitude,
      rightOptionHintAr: longitude,
    };
  }

  isFieldImageUrl1Correct() {
    return true;
  }

  render() {
    const {
      sections,
      feedbackHint,
      clickLimit,
      endAtA,

      isGamePuzzleSubTypeTap,
      videoFromGallery,
      flipsNeeded,
      deadCount,
      gameTime,
      gameColumns,
      gameRows,
      gameSColumns,
      resetGameDays,
      resetLimitPerUser,
      contactNumber,
      winnersBySelected,
      winnersByValue,
      qTitle,
      value1Placeholder,
      value1PlaceholderAr,
      rightOptionHint,
      rightOptionHintAr,
      latitude,
      longitude,
      showValidationMsg,
    } = this.state;
    const {app, activities, activityData, classes, isXS} = this.props;

    // let flipsNeededTextKey = null;
    // let flipsNeededHintKey = null;
    // let deadCountTextKey = null;
    // if (activityData.type === constants.activity.types.COLLECT_STARS) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    // } else if (activityData.type === constants.activity.types.GAME_FIND_HIDDEN) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    //   deadCountTextKey = 'activity.manage.emptyCardsCount';
    // } else if (activityData.type === constants.activity.types.GAME_MATCH_PAIR) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    // } else if (activityData.type === constants.activity.types.GAME_MATCH_THREE) {
    //   flipsNeededTextKey = 'activity.manage.movesLimit';
    // } else if (activityData.type === constants.activity.types.GAME_PUZZLE) {
    //   flipsNeededTextKey = 'activity.manage.movesLimit';
    //   flipsNeededHintKey = 'activity.manage.hintPuzzleMovesCount';
    // } else {
    //   flipsNeededTextKey = 'activity.manage.flipsNeeded';
    //   deadCountTextKey = 'activity.manage.deadCardsCount';
    // }

    const showFeedback = activityData.type === constants.activity.types.VISITOR_OPINION;
    const showContactNumber = activityData.type === constants.activity.types.EVENT;
    const showParticipateLimit = activityData.type === constants.activity.types.EVENT;
    // const showGameSubType = activityData.type === constants.activity.types.GAME_PUZZLE;
    const showGameSubType = false;
    const showContentTypes = activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.SOCIAL_CONTENT;
    const showGameImageUrl1 = activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS;
    const showGameImageUrl2 = activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER;
    const showPredictionEndDate = activityData.type === constants.activity.types.PREDICTION;
    const showLocationTitle = activityData.type === constants.activity.types.IDENTIFY_LOCATION;
    const showPickLocationMap = activityData.type === constants.activity.types.IDENTIFY_LOCATION;
    const showValuePlaceholders = false;
    // const showValuePlaceholders = activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.COLLECT_STARS
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_BRAND_RACE;
    const showGameTime = false;
    // const showGameTime = activityData.type === constants.activity.types.GAME_FLIP_CARD
    //   || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //   || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_PUZZLE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE;
    const showGameWinnersBy = false;
    // const showGameWinnersBy = activityData.type === constants.activity.types.CHALLENGE
    //   || activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.COLLECT_STARS
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.IDENTIFY_LOCATION;

    let winnersByValuePlaceholderKey = null;
    if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      winnersByValuePlaceholderKey = 'activity.manage.identifyLocation.minKmsToWinEligible'
    } else {
      winnersByValuePlaceholderKey = 'activity.manage.minValueToWinEligible'
    }
    let predictionTitleKey = null;
    let predictionAnswer1Key = null;
    let predictionAnswer2Key = null;
    if (activityData.type === constants.activity.types.PREDICTION) {
      predictionTitleKey = 'activity.manage.predictionTitle';
      predictionAnswer1Key = 'activity.manage.predictionAnswer1';
      predictionAnswer2Key = 'activity.manage.predictionAnswer2';
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      predictionTitleKey = 'activity.manage.identifyLocationTitle';
      predictionAnswer1Key = 'activity.manage.predictionAnswer1';
      predictionAnswer2Key = 'activity.manage.predictionAnswer2';
    }
    let value1TextKey = null;
    let value2TextKey = null;
    let valueLength = 20;
    if (activityData.type === constants.activity.types.PREDICTION) {
      value1TextKey = 'activity.manage.predictionPlaceholder1';
      value2TextKey = 'activity.manage.predictionPlaceholder2';
      valueLength = 200;
    } else if (activityData.type === constants.activity.types.LIKE_USER) {
      value1TextKey = 'activity.manage.sharePlaceholderText';
      valueLength = 20;
    } else if (activityData.type === constants.activity.types.GAME_BRAND_RACE) {
      value1TextKey = 'activity.manage.brandPlaceholderText';
      valueLength = 20;
    } else {
      value1TextKey = 'activity.manage.scoreValuePlaceholder';
      valueLength = 20;
    }

    const hideBg = activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE;
    return (
      <div className={classes.formActivityWide}>
        {/*<SectionHeaderView labelId={'activity.bgAudio'} />*/}
        {/*{this.getBgAudioView(0)}*/}
        {/*<FieldSpace multiplier={2}/>*/}

        {/*<SectionHeaderView labelId={'activity.describeLocation'} extraBottomSpace={true}/>*/}

        {!isXS ? <MediaPlaceholder labelId={'activity.locationImage'} /> : null}
        <div className={isXS ? classes.flexRowNoCenter : classes.viewColumnFullWidthNoCenter1}>
          {this.getImage1PickerView(0)}
          <FieldSpace vertical={isXS}/>

          <TextField
            variant="filled"
            required
            fullWidth
            multiline
            rows={1}
            rowsMax={8}
            size="small"
            type="text"
            id="qTitle"
            name="qTitle"
            label={<FormattedMessage id={predictionTitleKey} />}
            InputProps={{disableUnderline: true}}
            inputProps={{maxLength: 200}}
            value={qTitle}
            onChange={this.onChange}
            error={showValidationMsg && this.isTitleIncorrect(qTitle)}
            helperText={showValidationMsg && this.isTitleIncorrect(qTitle) && <FormattedMessage id='generic.validation.required' />}
          />
        </div>
        <FieldSpace multiplier={2}/>

        <SectionHeaderView labelId={'activity.correctLocation'} subLabelId={'activity.correctLocationHint'}/>
        {this.getPickLocationView()}

        {this.renderDialogView()}
        {this.renderSnackBar()}
      </div>
    )
  }

  renderDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={showDialog}
        {...dialogInfo}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog = () => {
    this.setState({showDialog: false, dialogInfo: null});
  };

  getBgAudioView(space = FIELD_SPACE) {
    const {activityData, app, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let isRequired = false;
    let size = isXS ? 'xsmall' : 'small';
    let imagePlaceholderId = 'activity.manage.bgAudio';
    const maxWidthHeight = (activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) ? IMAGE_MAX_WIDTH_HEIGHT : IMAGE_PROFILE_MAX_WIDTH_HEIGHT;

    let error = null;
    if (showValidationMsg) {
      if (!this.isFieldImageUrl1Correct()) {
        error = this.context.intl.formatMessage({id: 'generic.validation.required'});
      }
    }
    // const spacing = isXS ? SPACE_IMAGE_XS : SPACE_IMAGE;

    return (
      <div style={{}}>
        <SingleFilePicker
          key={'SFP1'}
          required={isRequired}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_AUDIO_MIMES}
          maxFileSize={AUDIO_MAX_SIZE}
          maxDuration={this.maxBgAudioDuration}
          initialFiles={this.bgAudioInitialFiles}
          onError={this.onErrorFiles}
          onChange={(files) => {
            this.onChangeFiles(files, 'bgAudioUrl');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'bgAudioUrl');
          }}
          error={error != null}
          errorText={error}
        />
      </div>
    );
  }

  getPickLocationView() {
    const {classes, isXS, isDrawerHidden, app} = this.props;
    const {latitude, longitude, showValidationMsg} = this.state;

    let locationError = null;
    if (showValidationMsg) {
      if (!latitude || !longitude) {
        locationError = <FormattedMessage id='generic.validation.required'/>;
      }
    }

    let markers = null;
    let buttonRemove = null;
    if (latitude || longitude) {
      markers = [{label: '', position: {lat: latitude, lng: longitude}}];
      buttonRemove = (
        <Button
          disableElevation
          className={classes.negativeButton}
          variant={'outlined'}
          color="secondary"
          size={'small'}
          style={{marginRight: app.isLTR ? 8 : 0, marginLeft: app.isLTR ? 0 : 8}}
          startIcon={<DeleteIcon />}
          onClick={this.onLocationReset}>
          <FormattedMessage id={'generic.remove'} />
        </Button>
      );
    }
    return (
      <React.Fragment>
        <div className={classes.inputField} style={{minHeight: 50, borderColor: locationError ? ColorNegative : ColorFieldBorder}}>
          <div className={classes.flexRow}>
            <div className={classes.flexColumnNoCenter}>
              {latitude || longitude ?
                <div className={classes.flexColumnNoCenter} style={{marginTop: 6}}>
                  <TextView numberOfLines={3} textAlign={'left'} variant={'body2'} fontWeight={FontWeightMedium}><FormattedHTMLMessage id={'activity.manage.geofenceCenter'} values={{latitude: ValueHelper.getDisplayValue(latitude, 4), longitude: ValueHelper.getDisplayValue(longitude, 4)}} /></TextView>
                </div>
                : <InputLabel required={true}>{this.context.intl.formatMessage({id: 'activity.location'})}</InputLabel>
              }
            </div>
            <div className={classes.viewRow} style={{alignItems: 'center', marginLeft: 8}}>
              {/*{!isDrawerHidden ? buttonRemove : null}*/}
              {buttonRemove}
              <Button
                disableElevation
                variant={'contained'}
                color="primary"
                size={'small'}
                startIcon={<AddLocationIcon />}
                onClick={this.openPickLocationDialog}>
                <FormattedMessage id={latitude || longitude ? 'generic.edit' : 'generic.add'} />
              </Button>
              {/*{isDrawerHidden ? buttonRemove : null}*/}
            </div>
          </div>
          {latitude || longitude ?
            <div className={classes.flexColumnNoCenter} style={{marginTop: 8, marginBottom: 4}}>
              <View
                style={{position: 'relative', height: 300}}>
                <View style={{position: 'relative'}}>
                  <MapField
                    readOnly={true}
                    // width={300}
                    height={300}
                    isLTR={app.isLTR}
                    classes={classes}
                    center={{lat: latitude, lng: longitude}}
                    radius={100}
                    radiusNeeded={true}
                    onCenterChanged={() => {}}
                    markers={markers}
                    styleMapContainer={{padding: 0}}
                  />
                </View>
                <TouchableOpacity
                  onClick={this.openPickLocationDialog}
                  style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}/>
              </View>
            </div>
            : null
          }
        </div>
        {locationError ?
          <FormHelperText className={classes.helperError} style={{marginLeft: 12}}>{locationError}</FormHelperText>
          : null
        }
        <FieldSpace />
      </React.Fragment>
    )
  }

  getPickLocationDialogContentView = () => {
    const {classes, app, isXS} = this.props;
    const {latitude, longitude} = this.state;
    let width = Math.min(window.appWidth - 48, 500);
    width = Math.min(window.appHeight - 420, width);
    const height = width + MAP_EXTRA_HEIGHT;
    let isLocationZoomCorrect = false;
    if (this.selectedGeofence) {
      isLocationZoomCorrect = this.selectedGeofence.zoom >= ZOOM_COARSE_LOCATION;
    }
    return (
      <div className={classes.viewColumn} style={{minWidth: width, minHeight: height}}>
        <div style={{marginBottom: 4, marginLeft: 8, marginRight: 8}}>
          <TextView textAlign={'center'} variant={'body2'} color={ColorSubTitle}>{this.context.intl.formatMessage({id: 'activity.manage.hintSelectGeofence'})}</TextView>
        </div>
        <MapField
          styleMapContainer={{paddingLeft: isXS ? 0 : 8, paddingRight: isXS ? 0 : 8}}
          isLTR={app.isLTR}
          classes={classes}
          canDisable={true}
          width={width}
          center={latitude ? {lat: latitude, lng: longitude} : null}
          onCenterChanged={this.onMapChanged}
        />
        {this.selectedGeofence ?
          <div style={{marginBottom: 4, marginLeft: 8, marginRight: 8}}>
            <TextView textAlign={'center'} variant={'body2'} color={isLocationZoomCorrect ? ColorGreen : ColorNegative}>{this.context.intl.formatMessage({id: isLocationZoomCorrect ? 'location.pickLocationGoodToGo' : 'location.zoomInMapToPickLocation'})}</TextView>
          </div>
          : null
        }
      </div>
    );
  };

  onMapChanged = (data) => {
    if (data) {
      const latitude = data.center.lat;
      const longitude = data.center.lng;
      const zoom = data.zoom;
      this.selectedGeofence = {latitude, longitude, zoom};
    } else {
      this.selectedGeofence = null;
    }
    this.reloadView();
  };

  openPickLocationDialog = () => {
    const dialogInfo = {
      title: this.context.intl.formatMessage({id: 'activity.selectLocation'}),
      renderContent: this.getPickLocationDialogContentView,
      positiveText: this.context.intl.formatMessage({id: 'generic.save'}),
      onPositiveClicked: this.onLocationPicked.bind(this),
      neutralText: this.context.intl.formatMessage({id: 'generic.cancel'}),
      onNeutralClicked: this.hideDialog
    };
    this.showDialog(dialogInfo);
  }

  onLocationPicked = () => {
    if (this.selectedGeofence && this.selectedGeofence.zoom < ZOOM_COARSE_LOCATION) {
      this.showSnackbar({
        snackbarMessageId: 'location.zoomInMapToPickLocation',
        snackbarType: 'error'
      });
      return;
    }

    if (this.selectedGeofence) {
      this.updateState({latitude: this.selectedGeofence.latitude, longitude: this.selectedGeofence.longitude, showValidationMsg: false});
      this.selectedGeofence = null;
    } else {
      this.updateState({latitude: null, longitude: null, showValidationMsg: false});
    }
    this.hideDialog();
  }

  onLocationReset = () => {
    this.updateState({latitude: null, longitude: null, showValidationMsg: false});
    this.selectedGeofence = null;
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  getImage1PickerView(space = FIELD_SPACE) {
    const {activityData, classes, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let isRequired = false;
    let size = isXS ? 'xsmall' : 'small';
    let imagePlaceholderId = null;
    let detailPlaceholderId = 'activity.manage.placeholderImageDescription';
    if (activityData.type === constants.activity.types.PREDICTION) {
      imagePlaceholderId = 'activity.manage.prediction1Image';
      previewImage = require('src/images/img_ph_1.png');
      detailPlaceholderId = 'activity.manage.placeholderImagePrediction1';
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      imagePlaceholderId = 'activity.manage.identifyLocationImage';
      detailPlaceholderId = 'activity.locationImageDesc';
    } else if (activityData.type === constants.activity.types.GAME_PUZZLE) {
      imagePlaceholderId = 'activity.manage.puzzleImage';
      previewImage = require('src/images/img_ph_p.png');
    } else if (activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
      imagePlaceholderId = 'activity.manage.puzzleImage';
      previewImage = require('src/images/img_ph_p.png');
    } else if (activityData.type === constants.activity.types.LIKE_USER) {
      imagePlaceholderId = 'activity.manage.sharePlaceholderImage';
      previewImage = require('src/images/img_ph_1.png');
    } else {
      imagePlaceholderId = 'activity.manage.cardPlaceholderImage';
      previewImage = require('src/images/img_ph_f.png');
    }
    const maxWidthHeight = (activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) ? IMAGE_MAX_WIDTH_HEIGHT : IMAGE_PROFILE_MAX_WIDTH_HEIGHT;

    let error = null;
    if (showValidationMsg) {
      if (!this.isFieldImageUrl1Correct()) {
        error = this.context.intl.formatMessage({id: 'generic.validation.required'});
      }
    }

    return (
      <SingleFilePicker
        key={'SFP1'}
        required={isRequired}
        hideDropzoneText={true}
        size={isXS ? 'xsmall' : 'small'}
        filesLimit={1}
        showPreviewsInDropzone={true}
        acceptedFiles={ACCEPTED_IMAGE_MIMES}
        maxFileSize={IMAGE_MAX_SIZE}
        maxWidthOrHeight={maxWidthHeight}
        aspectRatio={16/9}
        initialFiles={this.initialFiles1}
        onError={this.onErrorFiles}
        onChange={(files) => {
          this.onChangeFiles(files, 'imageUrl1');
        }}
        onDelete={(file) => {
          this.onDeleteFile(file, 'imageUrl1');
        }}
        error={error != null}
        errorText={error}
      />
    );
  }

  getMaxWidth() {
    return VIEW_BESIDE_PREVIEW_MAX_WIDTH;
  }

  isTitleIncorrect(title) {
    return (!title || title.trim().length === 0);
  }

  onCenterChanged = (data) => {
    let {latitude, longitude} = this.state;
    if (data) {
      latitude = data.center.lat;
      longitude = data.center.lng;
    }
    this.updateState({
      latitude: latitude,
      longitude: longitude,
      rightOptionHint: ''+ latitude,
      rightOptionHintAr: ''+ longitude,
    });
  };

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id) {
    const {
      imageUrl1,
      imageUrl2,
      bgAudioUrl
    } = this.state;

    let eFileUrl = null;
    let keyFileUrl = null;
    let keyFiles = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eFileUrl)) {
          lFileUrl = eFileUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      imageUrl2,
      imageFiles2,
      fileObjsImage2,
      bgAudioUrl,
      bgAudioFiles,
    } = this.state;

    let eFileUrl = null;
    let eFiles = null;
    let eFileObjs = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyFileObjs = null;
    let keyIsFileDeleted = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      eFiles = imageFiles1;
      eFileObjs = fileObjsImage1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyFileObjs = 'fileObjsImage1';
      keyIsFileDeleted = 'isImageDeleted1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      eFiles = imageFiles2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyIsFileDeleted = 'isImageDeleted2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      eFiles = bgAudioFiles;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
      keyIsFileDeleted = 'isBgAudioDeleted';
    }

    let lFiles = [];
    let lFileUrl = eFileUrl;
    if (eFiles) {
      let index = 0;
      eFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eFileUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles, [keyIsFileDeleted]: true});
  }

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'feedbackHint' || event.target.name === 'qTitle') {
      value = value.replace("\n", " ");
    } else if (event.target.name === 'winPoints'
      || event.target.name === 'winLimit'
      || event.target.name === 'winILimit'
      || event.target.name === 'clickLimit'
    ) {
      const maxValue = constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }

    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityIdentifyLocation.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityIdentifyLocation.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityIdentifyLocation))
);
